import React from "react";
import ReactDOM from "react-dom";
import { Route, Routes, Link, BrowserRouter as Router } from "react-router-dom";

import "./index.css";
import App from "./App";
import Similar from "./Components/Similar";

const routing = (
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/Similar/:name" element={<Similar />} />
    </Routes>
  </Router>
);

ReactDOM.render(
  // <React.StrictMode>
  routing,
  /* </React.StrictMode> */
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
